/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * email_service
 * OpenAPI spec version: 0.1.0
 */

/**
 * Why a forward was not sent.
 */
export type ForwardCalendarEventErrorCode =
  (typeof ForwardCalendarEventErrorCode)[keyof typeof ForwardCalendarEventErrorCode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ForwardCalendarEventErrorCode = {
  not_found: 'not_found',
  invalid_recipients: 'invalid_recipients',
  inbox_unavailable: 'inbox_unavailable',
  send_failed: 'send_failed',
} as const;
